import { Button, EmptyState, Page } from '@/ds';
import { DocumentTitle } from '@/app/title';

export function NotFound() {
  return (
    <Page narrow>
      <DocumentTitle>Page not found</DocumentTitle>
      <div className="rq-panel">
        <EmptyState
          kind="no-results"
          title="There's no page at this address"
          action={
            <Button size="sm" href="/">
              Go to your start page
            </Button>
          }
        >
          The link may be old, or the record it pointed to no longer exists.
        </EmptyState>
      </div>
    </Page>
  );
}
